<template>
  <v-row class="my-2" no-gutters>
    <v-col no-gutters>
      <div class="d-flex font-weight-bold align-center">
        <v-icon v-if="icon" class="mr-1">{{ icon }}</v-icon>
        <span>{{ title }}</span>
      </div>
      <div v-if="subtitle">
        <small v-html="subtitle" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
